import { ReferralRequestCompletedCard } from './ReferralRequestCompletedCard';

const ReferralRequestCompletedPage = () => <ReferralRequestCompletedCard />;

export default ReferralRequestCompletedPage;
